/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Bytes: { input: any; output: any; }
  /**
   * 8 bytes signed integer
   *
   */
  Int8: { input: any; output: any; }
  /**
   * A string representation of microseconds UNIX timestamp (16 digits)
   *
   */
  Timestamp: { input: any; output: any; }
};

export enum Aggregation_Interval {
  Day = 'day',
  Hour = 'hour'
}

export type BlockChangedFilter = {
  number_gte: Scalars['Int']['input'];
};

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  number_gte?: InputMaybe<Scalars['Int']['input']>;
};

export type DisputeRequest = {
  __typename?: 'DisputeRequest';
  escrow: Escrow;
  from?: Maybe<Scalars['Bytes']['output']>;
  id: Scalars['ID']['output'];
  timestamp?: Maybe<Scalars['BigInt']['output']>;
};

export type DisputeRequest_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DisputeRequest_Filter>>>;
  escrow?: InputMaybe<Scalars['String']['input']>;
  escrow_?: InputMaybe<Escrow_Filter>;
  escrow_contains?: InputMaybe<Scalars['String']['input']>;
  escrow_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  escrow_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_gt?: InputMaybe<Scalars['String']['input']>;
  escrow_gte?: InputMaybe<Scalars['String']['input']>;
  escrow_in?: InputMaybe<Array<Scalars['String']['input']>>;
  escrow_lt?: InputMaybe<Scalars['String']['input']>;
  escrow_lte?: InputMaybe<Scalars['String']['input']>;
  escrow_not?: InputMaybe<Scalars['String']['input']>;
  escrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  escrow_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  escrow_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  escrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  escrow_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  escrow_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Bytes']['input']>;
  from_contains?: InputMaybe<Scalars['Bytes']['input']>;
  from_gt?: InputMaybe<Scalars['Bytes']['input']>;
  from_gte?: InputMaybe<Scalars['Bytes']['input']>;
  from_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  from_lt?: InputMaybe<Scalars['Bytes']['input']>;
  from_lte?: InputMaybe<Scalars['Bytes']['input']>;
  from_not?: InputMaybe<Scalars['Bytes']['input']>;
  from_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  from_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<DisputeRequest_Filter>>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum DisputeRequest_OrderBy {
  Escrow = 'escrow',
  EscrowAmount = 'escrow__amount',
  EscrowArbitratorExtraData = 'escrow__arbitratorExtraData',
  EscrowBuyer = 'escrow__buyer',
  EscrowBuyerFee = 'escrow__buyerFee',
  EscrowDeadline = 'escrow__deadline',
  EscrowFeeTimeout = 'escrow__feeTimeout',
  EscrowId = 'escrow__id',
  EscrowLastFeePaymentTime = 'escrow__lastFeePaymentTime',
  EscrowSeller = 'escrow__seller',
  EscrowSellerFee = 'escrow__sellerFee',
  EscrowSettlementTimeout = 'escrow__settlementTimeout',
  EscrowStatus = 'escrow__status',
  EscrowTemplateData = 'escrow__templateData',
  EscrowTemplateDataMappings = 'escrow__templateDataMappings',
  EscrowTimestamp = 'escrow__timestamp',
  EscrowToken = 'escrow__token',
  EscrowTransactionUri = 'escrow__transactionUri',
  From = 'from',
  Id = 'id',
  Timestamp = 'timestamp'
}

export type Escrow = {
  __typename?: 'Escrow';
  amount: Scalars['BigInt']['output'];
  arbitratorExtraData?: Maybe<Scalars['Bytes']['output']>;
  buyer: Scalars['Bytes']['output'];
  buyerFee?: Maybe<Scalars['BigInt']['output']>;
  createdEvents: Array<TransactionCreated>;
  deadline: Scalars['BigInt']['output'];
  disputeRequest?: Maybe<DisputeRequest>;
  feeTimeout?: Maybe<Scalars['BigInt']['output']>;
  hasToPayFees: Array<HasToPayFee>;
  id: Scalars['ID']['output'];
  lastFeePaymentTime?: Maybe<Scalars['BigInt']['output']>;
  payments: Array<Payment>;
  resolvedEvents: Array<TransactionResolved>;
  seller: Scalars['Bytes']['output'];
  sellerFee?: Maybe<Scalars['BigInt']['output']>;
  settlementProposals: Array<SettlementProposal>;
  settlementTimeout?: Maybe<Scalars['BigInt']['output']>;
  status?: Maybe<Status>;
  templateData?: Maybe<Scalars['String']['output']>;
  templateDataMappings?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  token?: Maybe<Scalars['Bytes']['output']>;
  transactionUri: Scalars['String']['output'];
  users: Array<User>;
};


export type EscrowCreatedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionCreated_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransactionCreated_Filter>;
};


export type EscrowHasToPayFeesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<HasToPayFee_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HasToPayFee_Filter>;
};


export type EscrowPaymentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Payment_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Payment_Filter>;
};


export type EscrowResolvedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionResolved_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransactionResolved_Filter>;
};


export type EscrowSettlementProposalsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SettlementProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SettlementProposal_Filter>;
};


export type EscrowUsersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<User_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<User_Filter>;
};

export type EscrowParameters = {
  __typename?: 'EscrowParameters';
  arbitratorExtraData: Scalars['Bytes']['output'];
  feeTimeout: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  settlementTimeout: Scalars['BigInt']['output'];
};

export type EscrowParameters_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<EscrowParameters_Filter>>>;
  arbitratorExtraData?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_contains?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_gt?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_gte?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  arbitratorExtraData_lt?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_lte?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_not?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  feeTimeout?: InputMaybe<Scalars['BigInt']['input']>;
  feeTimeout_gt?: InputMaybe<Scalars['BigInt']['input']>;
  feeTimeout_gte?: InputMaybe<Scalars['BigInt']['input']>;
  feeTimeout_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feeTimeout_lt?: InputMaybe<Scalars['BigInt']['input']>;
  feeTimeout_lte?: InputMaybe<Scalars['BigInt']['input']>;
  feeTimeout_not?: InputMaybe<Scalars['BigInt']['input']>;
  feeTimeout_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<EscrowParameters_Filter>>>;
  settlementTimeout?: InputMaybe<Scalars['BigInt']['input']>;
  settlementTimeout_gt?: InputMaybe<Scalars['BigInt']['input']>;
  settlementTimeout_gte?: InputMaybe<Scalars['BigInt']['input']>;
  settlementTimeout_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  settlementTimeout_lt?: InputMaybe<Scalars['BigInt']['input']>;
  settlementTimeout_lte?: InputMaybe<Scalars['BigInt']['input']>;
  settlementTimeout_not?: InputMaybe<Scalars['BigInt']['input']>;
  settlementTimeout_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum EscrowParameters_OrderBy {
  ArbitratorExtraData = 'arbitratorExtraData',
  FeeTimeout = 'feeTimeout',
  Id = 'id',
  SettlementTimeout = 'settlementTimeout'
}

export type Escrow_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<Escrow_Filter>>>;
  arbitratorExtraData?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_contains?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_gt?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_gte?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  arbitratorExtraData_lt?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_lte?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_not?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  arbitratorExtraData_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  buyer?: InputMaybe<Scalars['Bytes']['input']>;
  buyerFee?: InputMaybe<Scalars['BigInt']['input']>;
  buyerFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  buyerFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  buyerFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  buyerFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  buyerFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  buyerFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  buyerFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  buyer_contains?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_gt?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_gte?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  buyer_lt?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_lte?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_not?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  createdEvents_?: InputMaybe<TransactionCreated_Filter>;
  deadline?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_gt?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_gte?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  deadline_lt?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_lte?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_not?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  disputeRequest_?: InputMaybe<DisputeRequest_Filter>;
  feeTimeout?: InputMaybe<Scalars['BigInt']['input']>;
  feeTimeout_gt?: InputMaybe<Scalars['BigInt']['input']>;
  feeTimeout_gte?: InputMaybe<Scalars['BigInt']['input']>;
  feeTimeout_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feeTimeout_lt?: InputMaybe<Scalars['BigInt']['input']>;
  feeTimeout_lte?: InputMaybe<Scalars['BigInt']['input']>;
  feeTimeout_not?: InputMaybe<Scalars['BigInt']['input']>;
  feeTimeout_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  hasToPayFees_?: InputMaybe<HasToPayFee_Filter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastFeePaymentTime?: InputMaybe<Scalars['BigInt']['input']>;
  lastFeePaymentTime_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastFeePaymentTime_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastFeePaymentTime_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastFeePaymentTime_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastFeePaymentTime_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastFeePaymentTime_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastFeePaymentTime_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Escrow_Filter>>>;
  payments_?: InputMaybe<Payment_Filter>;
  resolvedEvents_?: InputMaybe<TransactionResolved_Filter>;
  seller?: InputMaybe<Scalars['Bytes']['input']>;
  sellerFee?: InputMaybe<Scalars['BigInt']['input']>;
  sellerFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sellerFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sellerFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sellerFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sellerFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sellerFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  sellerFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  seller_contains?: InputMaybe<Scalars['Bytes']['input']>;
  seller_gt?: InputMaybe<Scalars['Bytes']['input']>;
  seller_gte?: InputMaybe<Scalars['Bytes']['input']>;
  seller_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  seller_lt?: InputMaybe<Scalars['Bytes']['input']>;
  seller_lte?: InputMaybe<Scalars['Bytes']['input']>;
  seller_not?: InputMaybe<Scalars['Bytes']['input']>;
  seller_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  seller_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  settlementProposals_?: InputMaybe<SettlementProposal_Filter>;
  settlementTimeout?: InputMaybe<Scalars['BigInt']['input']>;
  settlementTimeout_gt?: InputMaybe<Scalars['BigInt']['input']>;
  settlementTimeout_gte?: InputMaybe<Scalars['BigInt']['input']>;
  settlementTimeout_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  settlementTimeout_lt?: InputMaybe<Scalars['BigInt']['input']>;
  settlementTimeout_lte?: InputMaybe<Scalars['BigInt']['input']>;
  settlementTimeout_not?: InputMaybe<Scalars['BigInt']['input']>;
  settlementTimeout_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  status?: InputMaybe<Status>;
  status_in?: InputMaybe<Array<Status>>;
  status_not?: InputMaybe<Status>;
  status_not_in?: InputMaybe<Array<Status>>;
  templateData?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_contains?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_ends_with?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_gt?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_gte?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_in?: InputMaybe<Array<Scalars['String']['input']>>;
  templateDataMappings_lt?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_lte?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_not?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  templateDataMappings_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_starts_with?: InputMaybe<Scalars['String']['input']>;
  templateDataMappings_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  templateData_contains?: InputMaybe<Scalars['String']['input']>;
  templateData_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  templateData_ends_with?: InputMaybe<Scalars['String']['input']>;
  templateData_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  templateData_gt?: InputMaybe<Scalars['String']['input']>;
  templateData_gte?: InputMaybe<Scalars['String']['input']>;
  templateData_in?: InputMaybe<Array<Scalars['String']['input']>>;
  templateData_lt?: InputMaybe<Scalars['String']['input']>;
  templateData_lte?: InputMaybe<Scalars['String']['input']>;
  templateData_not?: InputMaybe<Scalars['String']['input']>;
  templateData_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateData_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  templateData_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  templateData_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  templateData_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  templateData_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  templateData_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  templateData_starts_with?: InputMaybe<Scalars['String']['input']>;
  templateData_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  token?: InputMaybe<Scalars['Bytes']['input']>;
  token_contains?: InputMaybe<Scalars['Bytes']['input']>;
  token_gt?: InputMaybe<Scalars['Bytes']['input']>;
  token_gte?: InputMaybe<Scalars['Bytes']['input']>;
  token_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  token_lt?: InputMaybe<Scalars['Bytes']['input']>;
  token_lte?: InputMaybe<Scalars['Bytes']['input']>;
  token_not?: InputMaybe<Scalars['Bytes']['input']>;
  token_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  token_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionUri?: InputMaybe<Scalars['String']['input']>;
  transactionUri_contains?: InputMaybe<Scalars['String']['input']>;
  transactionUri_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transactionUri_ends_with?: InputMaybe<Scalars['String']['input']>;
  transactionUri_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transactionUri_gt?: InputMaybe<Scalars['String']['input']>;
  transactionUri_gte?: InputMaybe<Scalars['String']['input']>;
  transactionUri_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionUri_lt?: InputMaybe<Scalars['String']['input']>;
  transactionUri_lte?: InputMaybe<Scalars['String']['input']>;
  transactionUri_not?: InputMaybe<Scalars['String']['input']>;
  transactionUri_not_contains?: InputMaybe<Scalars['String']['input']>;
  transactionUri_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transactionUri_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transactionUri_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transactionUri_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionUri_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transactionUri_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transactionUri_starts_with?: InputMaybe<Scalars['String']['input']>;
  transactionUri_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<Scalars['String']['input']>>;
  users_?: InputMaybe<User_Filter>;
  users_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  users_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  users_not?: InputMaybe<Array<Scalars['String']['input']>>;
  users_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  users_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum Escrow_OrderBy {
  Amount = 'amount',
  ArbitratorExtraData = 'arbitratorExtraData',
  Buyer = 'buyer',
  BuyerFee = 'buyerFee',
  CreatedEvents = 'createdEvents',
  Deadline = 'deadline',
  DisputeRequest = 'disputeRequest',
  DisputeRequestFrom = 'disputeRequest__from',
  DisputeRequestId = 'disputeRequest__id',
  DisputeRequestTimestamp = 'disputeRequest__timestamp',
  FeeTimeout = 'feeTimeout',
  HasToPayFees = 'hasToPayFees',
  Id = 'id',
  LastFeePaymentTime = 'lastFeePaymentTime',
  Payments = 'payments',
  ResolvedEvents = 'resolvedEvents',
  Seller = 'seller',
  SellerFee = 'sellerFee',
  SettlementProposals = 'settlementProposals',
  SettlementTimeout = 'settlementTimeout',
  Status = 'status',
  TemplateData = 'templateData',
  TemplateDataMappings = 'templateDataMappings',
  Timestamp = 'timestamp',
  Token = 'token',
  TransactionUri = 'transactionUri',
  Users = 'users'
}

export type HasToPayFee = {
  __typename?: 'HasToPayFee';
  escrow: Escrow;
  id: Scalars['ID']['output'];
  party?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['BigInt']['output']>;
};

export type HasToPayFee_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<HasToPayFee_Filter>>>;
  escrow?: InputMaybe<Scalars['String']['input']>;
  escrow_?: InputMaybe<Escrow_Filter>;
  escrow_contains?: InputMaybe<Scalars['String']['input']>;
  escrow_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  escrow_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_gt?: InputMaybe<Scalars['String']['input']>;
  escrow_gte?: InputMaybe<Scalars['String']['input']>;
  escrow_in?: InputMaybe<Array<Scalars['String']['input']>>;
  escrow_lt?: InputMaybe<Scalars['String']['input']>;
  escrow_lte?: InputMaybe<Scalars['String']['input']>;
  escrow_not?: InputMaybe<Scalars['String']['input']>;
  escrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  escrow_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  escrow_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  escrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  escrow_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  escrow_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<HasToPayFee_Filter>>>;
  party?: InputMaybe<Scalars['String']['input']>;
  party_contains?: InputMaybe<Scalars['String']['input']>;
  party_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  party_ends_with?: InputMaybe<Scalars['String']['input']>;
  party_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  party_gt?: InputMaybe<Scalars['String']['input']>;
  party_gte?: InputMaybe<Scalars['String']['input']>;
  party_in?: InputMaybe<Array<Scalars['String']['input']>>;
  party_lt?: InputMaybe<Scalars['String']['input']>;
  party_lte?: InputMaybe<Scalars['String']['input']>;
  party_not?: InputMaybe<Scalars['String']['input']>;
  party_not_contains?: InputMaybe<Scalars['String']['input']>;
  party_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  party_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  party_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  party_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  party_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  party_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  party_starts_with?: InputMaybe<Scalars['String']['input']>;
  party_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum HasToPayFee_OrderBy {
  Escrow = 'escrow',
  EscrowAmount = 'escrow__amount',
  EscrowArbitratorExtraData = 'escrow__arbitratorExtraData',
  EscrowBuyer = 'escrow__buyer',
  EscrowBuyerFee = 'escrow__buyerFee',
  EscrowDeadline = 'escrow__deadline',
  EscrowFeeTimeout = 'escrow__feeTimeout',
  EscrowId = 'escrow__id',
  EscrowLastFeePaymentTime = 'escrow__lastFeePaymentTime',
  EscrowSeller = 'escrow__seller',
  EscrowSellerFee = 'escrow__sellerFee',
  EscrowSettlementTimeout = 'escrow__settlementTimeout',
  EscrowStatus = 'escrow__status',
  EscrowTemplateData = 'escrow__templateData',
  EscrowTemplateDataMappings = 'escrow__templateDataMappings',
  EscrowTimestamp = 'escrow__timestamp',
  EscrowToken = 'escrow__token',
  EscrowTransactionUri = 'escrow__transactionUri',
  Id = 'id',
  Party = 'party',
  Timestamp = 'timestamp'
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum Party {
  Buyer = 'Buyer',
  None = 'None',
  Seller = 'Seller'
}

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['BigInt']['output'];
  escrow: Escrow;
  id: Scalars['ID']['output'];
  party: Scalars['Bytes']['output'];
  timestamp?: Maybe<Scalars['BigInt']['output']>;
};

export type Payment_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<Payment_Filter>>>;
  escrow?: InputMaybe<Scalars['String']['input']>;
  escrow_?: InputMaybe<Escrow_Filter>;
  escrow_contains?: InputMaybe<Scalars['String']['input']>;
  escrow_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  escrow_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_gt?: InputMaybe<Scalars['String']['input']>;
  escrow_gte?: InputMaybe<Scalars['String']['input']>;
  escrow_in?: InputMaybe<Array<Scalars['String']['input']>>;
  escrow_lt?: InputMaybe<Scalars['String']['input']>;
  escrow_lte?: InputMaybe<Scalars['String']['input']>;
  escrow_not?: InputMaybe<Scalars['String']['input']>;
  escrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  escrow_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  escrow_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  escrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  escrow_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  escrow_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Payment_Filter>>>;
  party?: InputMaybe<Scalars['Bytes']['input']>;
  party_contains?: InputMaybe<Scalars['Bytes']['input']>;
  party_gt?: InputMaybe<Scalars['Bytes']['input']>;
  party_gte?: InputMaybe<Scalars['Bytes']['input']>;
  party_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  party_lt?: InputMaybe<Scalars['Bytes']['input']>;
  party_lte?: InputMaybe<Scalars['Bytes']['input']>;
  party_not?: InputMaybe<Scalars['Bytes']['input']>;
  party_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  party_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Payment_OrderBy {
  Amount = 'amount',
  Escrow = 'escrow',
  EscrowAmount = 'escrow__amount',
  EscrowArbitratorExtraData = 'escrow__arbitratorExtraData',
  EscrowBuyer = 'escrow__buyer',
  EscrowBuyerFee = 'escrow__buyerFee',
  EscrowDeadline = 'escrow__deadline',
  EscrowFeeTimeout = 'escrow__feeTimeout',
  EscrowId = 'escrow__id',
  EscrowLastFeePaymentTime = 'escrow__lastFeePaymentTime',
  EscrowSeller = 'escrow__seller',
  EscrowSellerFee = 'escrow__sellerFee',
  EscrowSettlementTimeout = 'escrow__settlementTimeout',
  EscrowStatus = 'escrow__status',
  EscrowTemplateData = 'escrow__templateData',
  EscrowTemplateDataMappings = 'escrow__templateDataMappings',
  EscrowTimestamp = 'escrow__timestamp',
  EscrowToken = 'escrow__token',
  EscrowTransactionUri = 'escrow__transactionUri',
  Id = 'id',
  Party = 'party',
  Timestamp = 'timestamp'
}

export type Query = {
  __typename?: 'Query';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  disputeRequest?: Maybe<DisputeRequest>;
  disputeRequests: Array<DisputeRequest>;
  escrow?: Maybe<Escrow>;
  escrowParameters?: Maybe<EscrowParameters>;
  escrowParameters_collection: Array<EscrowParameters>;
  escrows: Array<Escrow>;
  hasToPayFee?: Maybe<HasToPayFee>;
  hasToPayFees: Array<HasToPayFee>;
  payment?: Maybe<Payment>;
  payments: Array<Payment>;
  settlementProposal?: Maybe<SettlementProposal>;
  settlementProposals: Array<SettlementProposal>;
  transactionCreated?: Maybe<TransactionCreated>;
  transactionCreateds: Array<TransactionCreated>;
  transactionResolved?: Maybe<TransactionResolved>;
  transactionResolveds: Array<TransactionResolved>;
  user?: Maybe<User>;
  users: Array<User>;
};


export type Query_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type QueryDisputeRequestArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryDisputeRequestsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DisputeRequest_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DisputeRequest_Filter>;
};


export type QueryEscrowArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryEscrowParametersArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryEscrowParameters_CollectionArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EscrowParameters_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<EscrowParameters_Filter>;
};


export type QueryEscrowsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Escrow_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Escrow_Filter>;
};


export type QueryHasToPayFeeArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryHasToPayFeesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<HasToPayFee_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<HasToPayFee_Filter>;
};


export type QueryPaymentArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPaymentsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Payment_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Payment_Filter>;
};


export type QuerySettlementProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySettlementProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SettlementProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SettlementProposal_Filter>;
};


export type QueryTransactionCreatedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTransactionCreatedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionCreated_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TransactionCreated_Filter>;
};


export type QueryTransactionResolvedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTransactionResolvedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionResolved_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TransactionResolved_Filter>;
};


export type QueryUserArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryUsersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<User_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<User_Filter>;
};

export enum Resolution {
  RulingEnforced = 'RulingEnforced',
  SettlementReached = 'SettlementReached',
  TimeoutByBuyer = 'TimeoutByBuyer',
  TimeoutBySeller = 'TimeoutBySeller',
  TransactionExecuted = 'TransactionExecuted'
}

export type SettlementProposal = {
  __typename?: 'SettlementProposal';
  amount: Scalars['BigInt']['output'];
  escrow: Escrow;
  id: Scalars['ID']['output'];
  party?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['BigInt']['output'];
};

export type SettlementProposal_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<SettlementProposal_Filter>>>;
  escrow?: InputMaybe<Scalars['String']['input']>;
  escrow_?: InputMaybe<Escrow_Filter>;
  escrow_contains?: InputMaybe<Scalars['String']['input']>;
  escrow_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  escrow_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_gt?: InputMaybe<Scalars['String']['input']>;
  escrow_gte?: InputMaybe<Scalars['String']['input']>;
  escrow_in?: InputMaybe<Array<Scalars['String']['input']>>;
  escrow_lt?: InputMaybe<Scalars['String']['input']>;
  escrow_lte?: InputMaybe<Scalars['String']['input']>;
  escrow_not?: InputMaybe<Scalars['String']['input']>;
  escrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  escrow_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  escrow_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  escrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  escrow_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  escrow_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<SettlementProposal_Filter>>>;
  party?: InputMaybe<Scalars['String']['input']>;
  party_contains?: InputMaybe<Scalars['String']['input']>;
  party_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  party_ends_with?: InputMaybe<Scalars['String']['input']>;
  party_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  party_gt?: InputMaybe<Scalars['String']['input']>;
  party_gte?: InputMaybe<Scalars['String']['input']>;
  party_in?: InputMaybe<Array<Scalars['String']['input']>>;
  party_lt?: InputMaybe<Scalars['String']['input']>;
  party_lte?: InputMaybe<Scalars['String']['input']>;
  party_not?: InputMaybe<Scalars['String']['input']>;
  party_not_contains?: InputMaybe<Scalars['String']['input']>;
  party_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  party_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  party_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  party_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  party_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  party_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  party_starts_with?: InputMaybe<Scalars['String']['input']>;
  party_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum SettlementProposal_OrderBy {
  Amount = 'amount',
  Escrow = 'escrow',
  EscrowAmount = 'escrow__amount',
  EscrowArbitratorExtraData = 'escrow__arbitratorExtraData',
  EscrowBuyer = 'escrow__buyer',
  EscrowBuyerFee = 'escrow__buyerFee',
  EscrowDeadline = 'escrow__deadline',
  EscrowFeeTimeout = 'escrow__feeTimeout',
  EscrowId = 'escrow__id',
  EscrowLastFeePaymentTime = 'escrow__lastFeePaymentTime',
  EscrowSeller = 'escrow__seller',
  EscrowSellerFee = 'escrow__sellerFee',
  EscrowSettlementTimeout = 'escrow__settlementTimeout',
  EscrowStatus = 'escrow__status',
  EscrowTemplateData = 'escrow__templateData',
  EscrowTemplateDataMappings = 'escrow__templateDataMappings',
  EscrowTimestamp = 'escrow__timestamp',
  EscrowToken = 'escrow__token',
  EscrowTransactionUri = 'escrow__transactionUri',
  Id = 'id',
  Party = 'party',
  Timestamp = 'timestamp'
}

export enum Status {
  DisputeCreated = 'DisputeCreated',
  NoDispute = 'NoDispute',
  TransactionResolved = 'TransactionResolved',
  WaitingBuyer = 'WaitingBuyer',
  WaitingSeller = 'WaitingSeller',
  WaitingSettlementBuyer = 'WaitingSettlementBuyer',
  WaitingSettlementSeller = 'WaitingSettlementSeller'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  disputeRequest?: Maybe<DisputeRequest>;
  disputeRequests: Array<DisputeRequest>;
  escrow?: Maybe<Escrow>;
  escrowParameters?: Maybe<EscrowParameters>;
  escrowParameters_collection: Array<EscrowParameters>;
  escrows: Array<Escrow>;
  hasToPayFee?: Maybe<HasToPayFee>;
  hasToPayFees: Array<HasToPayFee>;
  payment?: Maybe<Payment>;
  payments: Array<Payment>;
  settlementProposal?: Maybe<SettlementProposal>;
  settlementProposals: Array<SettlementProposal>;
  transactionCreated?: Maybe<TransactionCreated>;
  transactionCreateds: Array<TransactionCreated>;
  transactionResolved?: Maybe<TransactionResolved>;
  transactionResolveds: Array<TransactionResolved>;
  user?: Maybe<User>;
  users: Array<User>;
};


export type Subscription_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type SubscriptionDisputeRequestArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionDisputeRequestsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DisputeRequest_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DisputeRequest_Filter>;
};


export type SubscriptionEscrowArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionEscrowParametersArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionEscrowParameters_CollectionArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EscrowParameters_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<EscrowParameters_Filter>;
};


export type SubscriptionEscrowsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Escrow_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Escrow_Filter>;
};


export type SubscriptionHasToPayFeeArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionHasToPayFeesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<HasToPayFee_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<HasToPayFee_Filter>;
};


export type SubscriptionPaymentArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPaymentsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Payment_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Payment_Filter>;
};


export type SubscriptionSettlementProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionSettlementProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SettlementProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SettlementProposal_Filter>;
};


export type SubscriptionTransactionCreatedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTransactionCreatedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionCreated_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TransactionCreated_Filter>;
};


export type SubscriptionTransactionResolvedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTransactionResolvedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionResolved_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TransactionResolved_Filter>;
};


export type SubscriptionUserArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionUsersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<User_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<User_Filter>;
};

export type TransactionCreated = {
  __typename?: 'TransactionCreated';
  escrow: Escrow;
  id: Scalars['ID']['output'];
};

export type TransactionCreated_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<TransactionCreated_Filter>>>;
  escrow?: InputMaybe<Scalars['String']['input']>;
  escrow_?: InputMaybe<Escrow_Filter>;
  escrow_contains?: InputMaybe<Scalars['String']['input']>;
  escrow_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  escrow_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_gt?: InputMaybe<Scalars['String']['input']>;
  escrow_gte?: InputMaybe<Scalars['String']['input']>;
  escrow_in?: InputMaybe<Array<Scalars['String']['input']>>;
  escrow_lt?: InputMaybe<Scalars['String']['input']>;
  escrow_lte?: InputMaybe<Scalars['String']['input']>;
  escrow_not?: InputMaybe<Scalars['String']['input']>;
  escrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  escrow_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  escrow_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  escrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  escrow_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  escrow_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<TransactionCreated_Filter>>>;
};

export enum TransactionCreated_OrderBy {
  Escrow = 'escrow',
  EscrowAmount = 'escrow__amount',
  EscrowArbitratorExtraData = 'escrow__arbitratorExtraData',
  EscrowBuyer = 'escrow__buyer',
  EscrowBuyerFee = 'escrow__buyerFee',
  EscrowDeadline = 'escrow__deadline',
  EscrowFeeTimeout = 'escrow__feeTimeout',
  EscrowId = 'escrow__id',
  EscrowLastFeePaymentTime = 'escrow__lastFeePaymentTime',
  EscrowSeller = 'escrow__seller',
  EscrowSellerFee = 'escrow__sellerFee',
  EscrowSettlementTimeout = 'escrow__settlementTimeout',
  EscrowStatus = 'escrow__status',
  EscrowTemplateData = 'escrow__templateData',
  EscrowTemplateDataMappings = 'escrow__templateDataMappings',
  EscrowTimestamp = 'escrow__timestamp',
  EscrowToken = 'escrow__token',
  EscrowTransactionUri = 'escrow__transactionUri',
  Id = 'id'
}

export type TransactionResolved = {
  __typename?: 'TransactionResolved';
  escrow: Escrow;
  id: Scalars['ID']['output'];
  resolution: Scalars['Int']['output'];
  timestamp?: Maybe<Scalars['BigInt']['output']>;
};

export type TransactionResolved_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<TransactionResolved_Filter>>>;
  escrow?: InputMaybe<Scalars['String']['input']>;
  escrow_?: InputMaybe<Escrow_Filter>;
  escrow_contains?: InputMaybe<Scalars['String']['input']>;
  escrow_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  escrow_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_gt?: InputMaybe<Scalars['String']['input']>;
  escrow_gte?: InputMaybe<Scalars['String']['input']>;
  escrow_in?: InputMaybe<Array<Scalars['String']['input']>>;
  escrow_lt?: InputMaybe<Scalars['String']['input']>;
  escrow_lte?: InputMaybe<Scalars['String']['input']>;
  escrow_not?: InputMaybe<Scalars['String']['input']>;
  escrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  escrow_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  escrow_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  escrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  escrow_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  escrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  escrow_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<TransactionResolved_Filter>>>;
  resolution?: InputMaybe<Scalars['Int']['input']>;
  resolution_gt?: InputMaybe<Scalars['Int']['input']>;
  resolution_gte?: InputMaybe<Scalars['Int']['input']>;
  resolution_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  resolution_lt?: InputMaybe<Scalars['Int']['input']>;
  resolution_lte?: InputMaybe<Scalars['Int']['input']>;
  resolution_not?: InputMaybe<Scalars['Int']['input']>;
  resolution_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum TransactionResolved_OrderBy {
  Escrow = 'escrow',
  EscrowAmount = 'escrow__amount',
  EscrowArbitratorExtraData = 'escrow__arbitratorExtraData',
  EscrowBuyer = 'escrow__buyer',
  EscrowBuyerFee = 'escrow__buyerFee',
  EscrowDeadline = 'escrow__deadline',
  EscrowFeeTimeout = 'escrow__feeTimeout',
  EscrowId = 'escrow__id',
  EscrowLastFeePaymentTime = 'escrow__lastFeePaymentTime',
  EscrowSeller = 'escrow__seller',
  EscrowSellerFee = 'escrow__sellerFee',
  EscrowSettlementTimeout = 'escrow__settlementTimeout',
  EscrowStatus = 'escrow__status',
  EscrowTemplateData = 'escrow__templateData',
  EscrowTemplateDataMappings = 'escrow__templateDataMappings',
  EscrowTimestamp = 'escrow__timestamp',
  EscrowToken = 'escrow__token',
  EscrowTransactionUri = 'escrow__transactionUri',
  Id = 'id',
  Resolution = 'resolution',
  Timestamp = 'timestamp'
}

export type User = {
  __typename?: 'User';
  escrows: Array<Escrow>;
  id: Scalars['ID']['output'];
  totalDisputedEscrows: Scalars['BigInt']['output'];
  totalEscrows: Scalars['BigInt']['output'];
  totalNoDisputedEscrows: Scalars['BigInt']['output'];
  totalResolvedEscrows: Scalars['BigInt']['output'];
  totalWaitingBuyerEscrows: Scalars['BigInt']['output'];
  totalWaitingSellerEscrows: Scalars['BigInt']['output'];
};


export type UserEscrowsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Escrow_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Escrow_Filter>;
};

export type User_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<User_Filter>>>;
  escrows_?: InputMaybe<Escrow_Filter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<User_Filter>>>;
  totalDisputedEscrows?: InputMaybe<Scalars['BigInt']['input']>;
  totalDisputedEscrows_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDisputedEscrows_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalDisputedEscrows_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalDisputedEscrows_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDisputedEscrows_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalDisputedEscrows_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalDisputedEscrows_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalEscrows?: InputMaybe<Scalars['BigInt']['input']>;
  totalEscrows_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalEscrows_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalEscrows_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalEscrows_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalEscrows_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalEscrows_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalEscrows_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalNoDisputedEscrows?: InputMaybe<Scalars['BigInt']['input']>;
  totalNoDisputedEscrows_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalNoDisputedEscrows_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalNoDisputedEscrows_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalNoDisputedEscrows_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalNoDisputedEscrows_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalNoDisputedEscrows_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalNoDisputedEscrows_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalResolvedEscrows?: InputMaybe<Scalars['BigInt']['input']>;
  totalResolvedEscrows_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalResolvedEscrows_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalResolvedEscrows_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalResolvedEscrows_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalResolvedEscrows_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalResolvedEscrows_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalResolvedEscrows_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalWaitingBuyerEscrows?: InputMaybe<Scalars['BigInt']['input']>;
  totalWaitingBuyerEscrows_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalWaitingBuyerEscrows_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalWaitingBuyerEscrows_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalWaitingBuyerEscrows_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalWaitingBuyerEscrows_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalWaitingBuyerEscrows_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalWaitingBuyerEscrows_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalWaitingSellerEscrows?: InputMaybe<Scalars['BigInt']['input']>;
  totalWaitingSellerEscrows_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalWaitingSellerEscrows_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalWaitingSellerEscrows_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalWaitingSellerEscrows_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalWaitingSellerEscrows_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalWaitingSellerEscrows_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalWaitingSellerEscrows_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum User_OrderBy {
  Escrows = 'escrows',
  Id = 'id',
  TotalDisputedEscrows = 'totalDisputedEscrows',
  TotalEscrows = 'totalEscrows',
  TotalNoDisputedEscrows = 'totalNoDisputedEscrows',
  TotalResolvedEscrows = 'totalResolvedEscrows',
  TotalWaitingBuyerEscrows = 'totalWaitingBuyerEscrows',
  TotalWaitingSellerEscrows = 'totalWaitingSellerEscrows'
}

export type _Block_ = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']['output']>;
  /** The block number */
  number: Scalars['Int']['output'];
  /** The hash of the parent block */
  parentHash?: Maybe<Scalars['Bytes']['output']>;
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']['output']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String']['output'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean']['output'];
};

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}

export type EscrowParametersDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EscrowParametersDetailsQuery = { __typename?: 'Query', escrowParameters?: { __typename?: 'EscrowParameters', id: string, feeTimeout: any, settlementTimeout: any, arbitratorExtraData: any } | null };

export type TransactionDetailsFragment = { __typename?: 'Escrow', id: string, buyer: any, seller: any, transactionUri: string, timestamp?: any | null, amount: any, token?: any | null, deadline: any, buyerFee?: any | null, sellerFee?: any | null, lastFeePaymentTime?: any | null, templateData?: string | null, templateDataMappings?: string | null, status?: Status | null, payments: Array<{ __typename?: 'Payment', id: string, amount: any, party: any, timestamp?: any | null }>, hasToPayFees: Array<{ __typename?: 'HasToPayFee', id: string, party?: string | null, timestamp?: any | null }>, createdEvents: Array<{ __typename?: 'TransactionCreated', id: string }>, resolvedEvents: Array<{ __typename?: 'TransactionResolved', id: string, resolution: number, timestamp?: any | null }>, settlementProposals: Array<{ __typename?: 'SettlementProposal', id: string, amount: any, party?: string | null, timestamp: any }>, disputeRequest?: { __typename?: 'DisputeRequest', id: string, from?: any | null, timestamp?: any | null, escrow: { __typename?: 'Escrow', id: string } } | null } & { ' $fragmentName'?: 'TransactionDetailsFragment' };

export type MyTransactionsQueryVariables = Exact<{
  userAddress: Scalars['Bytes']['input'];
  first: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  where?: InputMaybe<Escrow_Filter>;
  orderDirection?: InputMaybe<OrderDirection>;
}>;


export type MyTransactionsQuery = { __typename?: 'Query', escrows: Array<(
    { __typename?: 'Escrow' }
    & { ' $fragmentRefs'?: { 'TransactionDetailsFragment': TransactionDetailsFragment } }
  )> };

export type TransactionDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TransactionDetailsQuery = { __typename?: 'Query', escrow?: (
    { __typename?: 'Escrow' }
    & { ' $fragmentRefs'?: { 'TransactionDetailsFragment': TransactionDetailsFragment } }
  ) | null };

export type UserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', totalEscrows: any, totalResolvedEscrows: any, totalNoDisputedEscrows: any, totalDisputedEscrows: any, totalWaitingBuyerEscrows: any, totalWaitingSellerEscrows: any } | null };

export const TransactionDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Escrow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"}},{"kind":"Field","name":{"kind":"Name","value":"seller"}},{"kind":"Field","name":{"kind":"Name","value":"transactionUri"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"buyerFee"}},{"kind":"Field","name":{"kind":"Name","value":"sellerFee"}},{"kind":"Field","name":{"kind":"Name","value":"lastFeePaymentTime"}},{"kind":"Field","name":{"kind":"Name","value":"templateData"}},{"kind":"Field","name":{"kind":"Name","value":"templateDataMappings"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasToPayFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolvedEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolution"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settlementProposals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"timestamp"}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"EnumValue","value":"asc"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputeRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"escrow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<TransactionDetailsFragment, unknown>;
export const EscrowParametersDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EscrowParametersDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"escrowParameters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"feeTimeout"}},{"kind":"Field","name":{"kind":"Name","value":"settlementTimeout"}},{"kind":"Field","name":{"kind":"Name","value":"arbitratorExtraData"}}]}}]}}]} as unknown as DocumentNode<EscrowParametersDetailsQuery, EscrowParametersDetailsQueryVariables>;
export const MyTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Bytes"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Escrow_filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"escrows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"timestamp"}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"where"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Escrow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"}},{"kind":"Field","name":{"kind":"Name","value":"seller"}},{"kind":"Field","name":{"kind":"Name","value":"transactionUri"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"buyerFee"}},{"kind":"Field","name":{"kind":"Name","value":"sellerFee"}},{"kind":"Field","name":{"kind":"Name","value":"lastFeePaymentTime"}},{"kind":"Field","name":{"kind":"Name","value":"templateData"}},{"kind":"Field","name":{"kind":"Name","value":"templateDataMappings"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasToPayFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolvedEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolution"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settlementProposals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"timestamp"}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"EnumValue","value":"asc"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputeRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"escrow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<MyTransactionsQuery, MyTransactionsQueryVariables>;
export const TransactionDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransactionDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"escrow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Escrow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"}},{"kind":"Field","name":{"kind":"Name","value":"seller"}},{"kind":"Field","name":{"kind":"Name","value":"transactionUri"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"buyerFee"}},{"kind":"Field","name":{"kind":"Name","value":"sellerFee"}},{"kind":"Field","name":{"kind":"Name","value":"lastFeePaymentTime"}},{"kind":"Field","name":{"kind":"Name","value":"templateData"}},{"kind":"Field","name":{"kind":"Name","value":"templateDataMappings"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasToPayFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolvedEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolution"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settlementProposals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"timestamp"}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"EnumValue","value":"asc"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputeRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"escrow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<TransactionDetailsQuery, TransactionDetailsQueryVariables>;
export const UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"User"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalEscrows"}},{"kind":"Field","name":{"kind":"Name","value":"totalResolvedEscrows"}},{"kind":"Field","name":{"kind":"Name","value":"totalNoDisputedEscrows"}},{"kind":"Field","name":{"kind":"Name","value":"totalDisputedEscrows"}},{"kind":"Field","name":{"kind":"Name","value":"totalWaitingBuyerEscrows"}},{"kind":"Field","name":{"kind":"Name","value":"totalWaitingSellerEscrows"}}]}}]}}]} as unknown as DocumentNode<UserQuery, UserQueryVariables>;